<template>
    <div id="layout-config">
        <div class="grid">
            <div class="col">
                <a id="layout-config-button" class="layout-config-button" @click="onConfigButtonClick($event)">
                    <i class="pi pi-cog"></i>
                </a>
                <div class="layout-config" :class="{ 'layout-config-active': configActive }" @click="onConfigClick">
                    <h5>Menu Type</h5>
                    <div class="field-radiobutton">
                        <RadioButton name="menuMode" value="static" v-model="d_menuMode" id="mode1" @change="changeMenuMode('static')"></RadioButton>
                        <label for="mode1">Static</label>
                    </div>
                    <!-- <div class="field-radiobutton">
                <RadioButton name="menuMode" value="overlay" v-model="d_menuMode" id="mode2" @change="changeMenuMode('overlay')"></RadioButton>
                <label for="mode2">Overlay</label>
            </div> -->
                    <div class="field-radiobutton">
                        <RadioButton name="menuMode" value="slim" v-model="d_menuMode" id="mode3" @change="changeMenuMode('slim')"></RadioButton>
                        <label for="mode3">Slim</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton name="menuMode" value="horizontal" v-model="d_menuMode" id="mode4" @change="changeMenuMode('horizontal')"></RadioButton>
                        <label for="mode4">Horizontal</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton name="menuMode" value="sidebar" v-model="d_menuMode" id="mode5" @change="changeMenuMode('sidebar')"></RadioButton>
                        <label for="mode5">Sidebar</label>
                    </div>
                    <hr />

                    <h5>Color Scheme</h5>
                    <div class="field-radiobutton">
                        <RadioButton name="colorScheme" value="light" v-model="d_colorScheme" id="theme1" @change="changeColorScheme('light')"></RadioButton>
                        <label for="theme1">Light</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton name="colorScheme" value="dark" v-model="d_colorScheme" id="theme2" @change="changeColorScheme('dark')"></RadioButton>
                        <label for="theme2">Dark</label>
                    </div>
                    <hr />

                    <!-- <h5>Ripple Effect</h5>
                        <InputSwitch :modelValue="rippleActive" @update:modelValue="onRippleChange"  />
                    <hr /> -->

                    <h5>Tahun Ajaran</h5>
                    <div class="layout-themes">
                        <div class="col-12 lg:col-12 p-fluid">
                            <span class="mt-4">
                                <Dropdown
                                    :disabled="!cek_allow_tahun"
                                    :options="$store.state.simadu.tahun_ajaran"
                                    @change="$store.commit('set_tahun_aktif', tahun_selected), get_semester()"
                                    dataKey="value"
                                    optionLabel="text"
                                    optionValue="value"
                                    id="tahun_ajaran"
                                    required="true"
                                    autofocus
                                    v-model="tahun_selected"
                                />
                            </span>
                        </div>
                    </div>
                    <hr />

                    <h5>Semester</h5>
                    <div class="layout-themes">
                        <div class="col-12 lg:col-12 p-fluid">
                            <span class="mt-4">
                                <Dropdown
                                    :disabled="!cek_allow_semester"
                                    :options="$store.state.simadu.semester"
                                    @change="$store.commit('set_semester_aktif', semester_selected)"
                                    dataKey="value"
                                    optionLabel="text"
                                    optionValue="value"
                                    id="semester_ajaran"
                                    required="true"
                                    autofocus
                                    v-model="semester_selected"
                                />
                            </span>
                        </div>
                    </div>
                    <hr />

                    <h5>Jurusan</h5>
                    <div class="layout-themes">
                        <div class="col-12 lg:col-12 p-fluid">
                            <span class="mt-4">
                                <Dropdown
                                    :disabled="!cek_allow_fakultas"
                                    :options="fakultas"
                                    @change="set_new_fakultas(fakultas_selected), get_prodi(fakultas_selected)"
                                    dataKey="value"
                                    optionLabel="text"
                                    optionValue="value"
                                    id="prodi"
                                    required="true"
                                    autofocus
                                    v-model="fakultas_selected"
                                />
                            </span>
                        </div>
                    </div>

                    <h5>Prodi</h5>
                    <div class="layout-themes">
                        <div class="col-12 lg:col-12 p-fluid">
                            <span class="mt-4">
                                <Dropdown :disabled="!cek_allow_prodi" :options="prodis" @change="set_new_prodi(prodi_selected)" dataKey="value" optionLabel="text" optionValue="value" id="prodi" required="true" autofocus v-model="prodi_selected" />
                            </span>
                        </div>
                    </div>
                    <!-- <div class="layout-themes">
                        <div v-for="theme in componentThemes" :key="theme.name">
                            <a style="cursor: pointer" @click="changeComponentTheme(theme.name)" :title="theme.name" :style="{ 'background-color': theme.color }">
                                <i class="pi pi-check" v-if="componentTheme === theme.name"></i>
                            </a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppConfig',
    emits: ['config-button-click', 'config-click', 'change-color-scheme', 'change-menu-theme', 'change-component-theme', 'change-menu-mode'],
    props: {
        configActive: {
            type: Boolean,
            default: null,
        },
        configClick: {
            type: Boolean,
            default: null,
        },
        colorScheme: String,
        theme: String,
        componentTheme: String,
        menuMode: String,
    },
    data() {
        return {
            semester_selected: null,
            tahun_selected: null,
            prodi_selected: null,
            fakultas_selected: null,
            allow: {
                prodi: ['99', 'OPJ', 'OPADAK', 'PERJUS', 'KJUR', 'OUM', 'PA', 'OPPUS'],
                semester: ['99', 'OPJ', 'KPRO', 'OPP', 'OPADAK', 'KAUM', 'KSBAK', 'OUM', 'PA', 'KJUR'],
                tahun: ['99', 'OPJ', 'KPRO', 'OPP', 'OPADAK', 'KAUM', 'KSBAK', 'OUM', 'PA', 'KJUR'],
                fakultas: ['99', 'OPADAK', 'KAUM', 'KSBAK', 'OUM', 'OPPUS'],
            },
            themes: [
                { name: 'blue', color: '#0F8BFD' },
                // { name: 'green', color: '#0BD18A' },
                // { name: 'magenta', color: '#EC4DBC' },
                // { name: 'orange', color: '#FD9214' },
                // { name: 'purple', color: '#873EFE' },
                // { name: 'red', color: '#FC6161' },
                // { name: 'teal', color: '#00D0DE' },
                // { name: 'yellow', color: '#EEE500' },
            ],
            componentThemes: [
                { name: 'blue', color: '#0F8BFD' },
                // { name: 'green', color: '#0BD18A' },
                // { name: 'magenta', color: '#EC4DBC' },
                // { name: 'orange', color: '#FD9214' },
                // { name: 'purple', color: '#873EFE' },
                // { name: 'red', color: '#FC6161' },
                // { name: 'teal', color: '#00D0DE' },
                // { name: 'yellow', color: '#EEE500' },
            ],
            d_colorScheme: this.colorScheme,
            d_menuMode: this.menuMode,
        };
    },
    computed: {
        rippleActive() {
            return this.$primevue.config.ripple;
        },
        prodis() {
            return this.$store.state.simadu.prodi;
        },
        fakultas() {
            return this.$store.state.simadu.fakultas;
        },
        kode() {
            if (this.$store.state.simadu.role_aktif) {
                return this.$store.state.simadu.role_aktif.kode_role;
            } else {
                return null;
            }
        },
        fakultas_aktif() {
            return this.$store.state.simadu.fakultas_aktif ? this.$store.state.simadu.fakultas_aktif : null;
        },
        prodi_aktif() {
            return this.$store.state.simadu.prodi_aktif ? this.$store.state.simadu.prodi_aktif : null;
        },
        semester_aktif() {
            return this.$store.state.simadu.semester_aktif ? this.$store.state.simadu.semester_aktif : null;
        },
        tahun_aktif() {
            return this.$store.state.simadu.tahun_aktif ? this.$store.state.simadu.tahun_aktif : null;
        },
        cek_allow_prodi() {
            return this.allow.prodi.includes(this.kode);
        },
        cek_allow_semester() {
            return this.allow.semester.includes(this.kode);
        },
        cek_allow_tahun() {
            return this.allow.tahun.includes(this.kode);
        },
        cek_allow_fakultas() {
            return this.allow.fakultas.includes(this.kode);
        },
    },
    async mounted() {
        this.set_selected();
    },
    methods: {
        set_new_prodi(value) {
            if (this.prodi_aktif != value) {
                this.$store.commit('set_prodi_aktif', value);
            } else {
                this.$store.commit('set_prodi_aktif', null);
            }
        },
        set_new_fakultas(value) {
            if (this.fakultas_aktif != value) {
                this.$store.commit('set_fakultas_aktif', value);
            } else {
                this.$store.commit('set_fakultas_aktif', null);
            }
        },
        set_selected() {
            this.semester_selected = this.semester_aktif;
            this.fakultas_selected = this.fakultas_aktif;
            this.tahun_selected = this.tahun_aktif;
            this.prodi_selected = this.prodi_aktif;
        },
        async get_prodi(x) {
            let vm = this;
            if (x) {
                let prodi = await vm.$axiossimadu.post('prodi/listProdiByFakultasId', {
                    fakultas_id: x.id,
                });
                let y = await prodi.data.data.map((item) => {
                    return { ...item, value: item, text: item.kode_program_studi_prodi + ' - ' + item.nama_jenjang_didik + ' - ' + item.nama_program_studi_prodi };
                });
                vm.$store.dispatch('save_prodi', y);
            } else {
                vm.$store.dispatch('save_prodi', []);
                vm.$store.commit('set_prodi_aktif', null);
            }
        },
        async get_semester() {
            let vm = this;
            let semester = await vm.$axiossimadu.post('semester/listSemesterByTahunAjaranId', {
                tahun_ajaran_id: vm.tahun_aktif.id,
            });

            let y = await semester.data.data.map((item) => {
                return { ...item, value: item, text: item.nama_semester };
            });
            this.$store.dispatch('save_semester', y);
            // console.log(semester.data, 'semester');
        },
        changeTheme(theme) {
            this.$emit('change-menu-theme', theme);
        },
        changeComponentTheme(theme) {
            this.$emit('change-component-theme', theme);
        },
        // changeColorScheme(scheme) {
        //     this.$emit('change-color-scheme', scheme);
        // },
        changeColorScheme(scheme) {
            this.$store.commit('change_color_scheme', scheme);
        },
        onConfigButtonClick(event) {
            this.$emit('config-button-click', event);
            event.preventDefault();
        },
        onConfigClick(event) {
            this.$emit('config-click', event);
        },
        changeMenuMode(mode) {
            this.$emit('change-menu-mode', mode);
        },
        onRippleChange(value) {
            this.$primevue.config.ripple = value;
        },
    },
    watch: {
        fakultas_aktif: function (newV, oldV) {
            if (oldV != newV) {
                this.fakultas_selected = newV;
            }
        },
        prodi_aktif: function (newV, oldV) {
            if (oldV != newV) {
                // console.log(newV, 'config prodi');
                this.prodi_selected = newV;
            }
        },
        semester_aktif: function (newV, oldV) {
            if (oldV != newV) {
                this.semester_selected = newV;
            }
        },
        tahun_aktif: function (newV, oldV) {
            if (oldV != newV) {
                this.get_semester();
                this.tahun_selected = newV;
            }
        },
    },
};
</script>

<style scoped>
.layout-config .layout-themes {
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
</style>
